import React, { useState } from 'react'
import {
  Nav,
  Collapse,
  NavLink,
  NavbarBrand,
  NavItem,
  Navbar,
  ButtonToggle,
  Container,
} from 'reactstrap'

function Header() {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const toggle = () => setIsOpen(!isOpen)

  return (
    <header className="Header sticky-top">
      <Navbar color="faded" dark expand="md" className="bg-dark">
        <Container>
          <NavbarBrand className="logo my-md-3 my-1" href="/">
            <span className="logo-text">A</span>
          </NavbarBrand>
          <ButtonToggle
            color="transparent"
            className="ButtonToggle border-0 d-block d-md-none"
          >
            <span onClick={toggle}>
              <i />
              <i />
              <i />
            </span>
          </ButtonToggle>
          <Collapse isOpen={isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink target="_blank" href="https://github.com/allanncruz">
                  <i className="fab fa-github-alt mr-2" />
                  Github
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  target="_blank"
                  href="https://www.linkedin.com/in/allan-cruz-002b0429/"
                >
                  <i className="fab fa-linkedin-in mr-2" />
                  Linkedin
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  )
}

export default Header
